module.exports = __webpack_public_path__ + "static/media/muse_nyarubondo_mwogo_road11.edcbd298.jpg";